var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 7.625C0.953125 7.85938 0.953125 8.1875 1.1875 8.42188L8.07812 15.3594C8.26562 15.5938 8.64062 15.5938 8.875 15.3594L9.76562 14.4219C10 14.1875 10 13.8594 9.76562 13.625L4.23438 8L9.76562 2.42188C10 2.1875 10 1.8125 9.76562 1.625L8.875 0.6875C8.64062 0.453125 8.26562 0.453125 8.07812 0.6875L1.1875 7.625Z",
    fill: "#1A86E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.7f8c92a5.svg";
export { ForwardRef as ReactComponent };